import useGetAccessToken from "./useGetAccessToken";

import getApiClient from "lib/apiClient/getApiClient";

const useGetApiClient = () =>
  getApiClient({
    accessToken: useGetAccessToken(),
  });

export default useGetApiClient;
